import { useQuery } from "@tanstack/react-query"

import { getCookie } from "@/utils/cookieUtils"

import { bffApi } from "../apiClient"
import SalePeriod from "../models/SalePeriod"
import queryKeys from "../queryKeys"

type SalePeriodResponse = {
  startDate: string
  endDate: string
  unavailableDates: string[]
}

const useSalePeriodQuery = (resortId: number) => {
  return useQuery<SalePeriod | null>({
    queryKey: queryKeys.salePeriod(resortId),
    queryFn: async () => {
      const showLockedPeriods = getCookie("skistar-show-locked-periods")
      const headers = showLockedPeriods
        ? { "Show-Locked-Periods": "true" }
        : undefined

      const res = await bffApi.get<SalePeriodResponse>("saleperiod", {
        params: { resortId },
        headers,
      })

      if (!res.data) return null

      // Transform ISO strings to Date objects
      return {
        startDate: new Date(res.data.startDate),
        endDate: new Date(res.data.endDate),
        unAvailableDates: res.data.unavailableDates.map(
          (date) => new Date(date)
        ),
      }
    },
    staleTime: 0,
  })
}

export default useSalePeriodQuery
